import moment from 'moment'
import { DocumentDuplicateIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const formatDate = value => (value && moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '—')

const getStartDate = project => {
	const steps = Array.isArray(project?.steps) ? project.steps : []
	const dates = steps
		.map(step => step?.data_rozpoczecia)
		.filter(value => value && moment(value).isValid())
		.map(value => moment(value))
		.sort((a, b) => a.valueOf() - b.valueOf())

	return dates.length ? formatDate(dates[0]) : formatDate(project?.data_rozpoczecia || project?.created)
}

export default function ProjectsTableRow({ project, onDelete, onDuplicate }) {
	const { t } = useTranslation()
	const trainerNames = [...new Set(
		(Array.isArray(project?.steps) ? project.steps : []).flatMap(step => (
			Array.isArray(step.trainerNames) && step.trainerNames.length
				? step.trainerNames
				: (Array.isArray(step.pozycje) ? step.pozycje.map(item => item.trainerName) : [])
		)).map(name => `${name || ''}`.trim()).filter(Boolean)
	)]
	const trainerNamesFallback = Array.isArray(project?.trainerNames)
		? project.trainerNames.map(name => `${name || ''}`.trim()).filter(Boolean)
		: []
	const displayTrainerNames = trainerNames.length ? trainerNames : trainerNamesFallback

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap text-gray-900">
				{getStartDate(project)}
			</td>
			<td className="py-3 px-4 border-b border-gray-200">
				<Link
					to={`/centrumSzkolen/projekty/details/${project._id}`}
					className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{project.nazwa || '—'}
				</Link>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-gray-900">
				{displayTrainerNames.length ? displayTrainerNames.join(', ') : '—'}
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-right">
				<div className="inline-flex items-center gap-2">
					<Link
						to={`/centrumSzkolen/projekty/edit/${project._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
					>
						<PencilIcon className="h-4 w-4" />
						{t('projects.list.table.edit')}
					</Link>
					<button
						type="button"
						onClick={() => onDuplicate(project)}
						className="inline-flex items-center gap-1 rounded-md border border-indigo-100 bg-indigo-50 px-3 py-1.5 text-sm font-medium text-indigo-700 hover:bg-indigo-100"
					>
						<DocumentDuplicateIcon className="h-4 w-4" />
						{t('projects.list.table.duplicate', { defaultValue: 'Powiel' })}
					</button>
					<button
						type="button"
						onClick={() => onDelete(project)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100"
					>
						<TrashIcon className="h-4 w-4" />
						<span>{t('projects.list.table.delete')}</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
